module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingContent),
      expression: "loadingContent",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde um momento..."
    }
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "response": _vm.response,
      "config": _vm.config,
      "itens": _vm.formDataItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('Config', {
    attrs: {
      "consulta": _vm.formData.result
    }
  }), _vm._v(" "), (false) ? _c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "button": "",
      "title": "Clique aqui para imprimir o ASO desta consulta"
    },
    on: {
      "click": _vm.onASO
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Imprimir ASO\n            ")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "button": "",
      "title": "Clique aqui para imprimir a Ficha Clínica desta consulta"
    },
    on: {
      "click": _vm.onFemo
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Imprimir Ficha Clínica\n            ")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "disabled": "",
      "button": "",
      "title": "Clique aqui para Liberar o ASO desta consulta"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Liberar ASO\n              ")])], 1) : _vm._e()], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a310fe3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/credenciada/consulta/editar.vue
// module id = 1528
// module chunks = 45